import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isIOs } from '../../misc/selectors'
import { processUploadedFiles } from '../../misc/utilities'
import { browserHistory } from 'react-router'
import { extractFromUrl } from '../../actions'

const mapStateToProps = (state, ownProps) => {
  const { videos, me } = state

  return {
    isIOs: isIOs(state),
  }
}

class FooterCTA extends Component {
  render() {
    return (
      <div className="footer-cta-pane">
        <form ref="fileInputForm" style={{ display: 'none' }}>
          <input
            id="upload-input"
            multiple={!this.props.isIOs}
            type="file"
            ref="fileInput"
            onChange={() => {
              const files = this.refs.fileInput.files
              processUploadedFiles(this.props.dispatch, files).then(() => {
                this.refs.fileInputForm.reset()
              })
            }}
          />
        </form>
        <span className="footer-text">Getting started is easy - no signup required.</span>
        <div className="footer-form">
          <input type="submit" style={{ visibility: 'hidden', position: 'absolute' }} />
          <form ref="fileInputForm" style={{ display: 'none' }}>
            <input
              id="upload-input"
              multiple={!this.props.isIOs}
              type="file"
              ref="fileInput"
              onChange={() => {
                const files = this.refs.fileInput.files
                processUploadedFiles(this.props.dispatch, files).then(() => {
                  this.refs.fileInputForm.reset()
                })
              }}
            />
          </form>
          <button
            className="upload-button blue-button"
            onClick={(e) => {
              e.preventDefault()
              this.refs.fileInput.click()
            }}
          >Upload your first video</button>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(FooterCTA)
